






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'Alert' })
export default class extends Vue {
	// --- props

	@Prop({ default: '', type: String }) public readonly type!: string;
}
